const HEIGHT_FORMAT = '#\' ##"'
const COMPONENT_NAME = 'bmi-calculator'

export { HEIGHT_FORMAT, COMPONENT_NAME }
